import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ApContentModule } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';

import { BrowserErrorComponent } from './browser-error/browser-error.component';

/**
 * @ngdoc module
 * @name MKErrorModule
 */
@NgModule({
    declarations: [BrowserErrorComponent],
    imports: [ApIllustrationComponent, ApContentModule, RouterModule]
})
export class MKErrorModule {}
